import Image from "next/image"
import Link from "next/link"

interface QuickLinkProps {
  href: string
  children: React.ReactNode
}

const QuickLink = ({ href, children }: QuickLinkProps) => (
  <li>
    <Link 
      href={href} 
      className="text-[#171A20] hover:text-[#171A20]/80 transition-colors duration-200 inline-block py-1"
    >
      {children}
    </Link>
  </li>
)

export function Footer() {
  const currentYear = new Date().getFullYear()
  
  const quickLinks = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About" },
    { href: "/services", label: "Services" },
    { href: "/our-work", label: "Our Work" },
    { href: "/contact", label: "Contact" }
  ]

  const resourceLinks = [
    { href: "/case-studies", label: "Case Studies" },
    { href: "/resources", label: "Resources" },
    { href: "/faq", label: "FAQ" },
    { href: "/support", label: "Support" }
  ]

  const industryLinks = [
    { href: "/industries/healthcare", label: "Healthcare" },
    { href: "/industries/finance", label: "Finance" },
    { href: "/industries/technology", label: "Technology" },
    { href: "/industries/retail", label: "Retail" }
  ]

  return (
    <footer className="bg-white text-[#171A20]">
      <div className="mx-auto max-w-[110rem] px-4 sm:px-6 lg:px-10 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Image
              src="/logos/sca.svg"
              alt="SCA Logo"
              width={40}
              height={14}
              className="mb-6"
              style={{ filter: 'brightness(0) saturate(100%) invert(12%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)' }}
            />
            <p className="text-[#171A20] max-w-md leading-relaxed mb-6">
              Empowering businesses through innovative solutions and strategic consulting services.
              We help organizations transform and thrive in the digital age.
            </p>
            {/* <div className="flex gap-4">
              <a href="https://twitter.com" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors duration-200">
                <Image src="/social/twitter.svg" alt="Twitter" width={20} height={20} className="brightness-0 invert" />
              </a>
              <a href="https://linkedin.com" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors duration-200">
                <Image src="/social/linkedin.svg" alt="LinkedIn" width={20} height={20} className="brightness-0 invert" />
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#171A20]">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map(link => (
                <QuickLink key={link.href} href={link.href}>
                  {link.label}
                </QuickLink>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#171A20]">Resources</h3>
            <ul className="space-y-2">
              {resourceLinks.map(link => (
                <QuickLink key={link.href} href={link.href}>
                  {link.label}
                </QuickLink>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#171A20]">Industries</h3>
            <ul className="space-y-2">
              {industryLinks.map(link => (
                <QuickLink key={link.href} href={link.href}>
                  {link.label}
                </QuickLink>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#171A20]/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#5C5E62]">
              © {currentYear} Sovereign Creative Agency. All rights reserved.
            </p>
            <div className="flex gap-8">
              <Link href="/privacy" className="text-sm text-[#5C5E62] hover:text-[#171A20] transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link href="/terms" className="text-sm text-[#5C5E62] hover:text-[#171A20] transition-colors duration-200">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer